module.exports = __webpack_public_path__ + "img/horizontal_6_3_pp3_3.e911fd23.png";